import { ComponentProps } from "react"

import type { AnyFieldApi } from "@tanstack/react-form"

import { Input } from "@/components/ui/Input"
import { cn } from "@/lib/shadcn-utils"

interface FormInputProps extends ComponentProps<"input"> {
  field: AnyFieldApi
  label: string
}

export function FormInput({
  field,
  label,
  className,
  ...props
}: FormInputProps) {
  const hasError = field.state.meta.errors.length > 0

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <label
        htmlFor={field.name}
        className="tw-text-2xl tw-font-medium tw-text-gray-600"
      >
        {label}
      </label>
      <Input
        id={field.name}
        name={field.name}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(e) => {
          field.handleChange(e.target.value)
        }}
        {...props}
        className={cn(
          "tw-text-3xl tw-border-2 tw-rounded-md tw-px-3 tw-py-2 focus:tw-outline-none",
          hasError
            ? "tw-border-red-600 focus:tw-border-red-600"
            : "tw-border-gray-500 focus:tw-border-emerald-600",
          className,
        )}
      />
    </div>
  )
}
